/* unplugin-vue-components disabled */import { render } from "./AddCard.vue?vue&type=template&id=428985cb&scoped=true&ts=true"
import script from "./AddCard.vue?vue&type=script&lang=ts"
export * from "./AddCard.vue?vue&type=script&lang=ts"

import "./AddCard.vue?vue&type=style&index=0&id=428985cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428985cb"]])

export default __exports__